import React, { useState, useEffect } from "react";
import Proptypes from "prop-types";
import { Button, CtaLink, AElement } from "../../Elements";
import {
	CloudinaryImage,
	AuthenticationModal,
} from "@website-builder/ui/shared/elements";
import { HeaderWrapper, Badge, UserAvatarWrapper } from "./styles";
import ReferralModal from "./ReferralModal";
import {
	getXCSRFToken,
	addToDataLayer,
} from "@website-builder/utilities-index";
import CareerTracksModal from "./CareerTracksModal";

const Header = (props) => {
	const {
		logo = { imageurl: "", altTag: "" },
		courses = [],
		students = [],
		howItWorks = [],
		forCompanies = [],
		mentors = [],
		exploreCareerpathsLink,
		careerAssessmentTestLink = null,
		apiBaseUrl,
		Link,
		studentsLinkWithoutDropdown,
		globalHostName,
		courseSlug,
		careerTracks,
		exploreCareerpathsHeader,
		isStaticBuild,
		outcomesLink,
		blankHeader,
		setUserDetailsProp,
	} = props;

	const [showCareerTracksModal, setShowCareerTracksModal] = useState(false);
	const [showLoginModal, setShowLoginModal] = useState(false);
	const [showHamburgerMenu, setShowhamburgerMenu] = useState(false);
	const [hamburgerSubmenu, sethamburgerSubmenu] = useState(null);
	const [referrerDetails, setReferrerDetails] = useState(null);
	const [userAvatar, setUserAvatar] = useState(null);
	const [showReferrerModal, setShowReferrerModal] = useState(false);
	const [showUserMenu, setShowUserMenu] = useState(false);
	const [showExplorePrograms, setShowExplorePrograms] = useState(false);
	const [fixHeader, setFixHeader] = useState(false);
	const [showMentorDashboard, setShowMentorDashboard] = useState(false);
	const [showCareerDashboard, setShowCareerDashboard] = useState(false);
	const [showMyCourses, setShowMyCourses] = useState(false);
	const [showMyLearning, setShowMyLearning] = useState(false);
	const [isStudent, setIsStudent] = useState(false);

	const userApiEndpoint = `${apiBaseUrl}/user/`;
	const signOutApiEndPoint = `${apiBaseUrl}/accounts/logout/`;
	const scrollToExplorePrograms = () => {
		const targetElement = document.getElementById("explore-programs");
		targetElement.scrollIntoView();
		window.scrollBy(0, -75);
	};

	useEffect(() => {
		fetch(userApiEndpoint, {
			credentials: "include",
		})
			.then((res) => res.json())
			.then((response) => {
				const { code } = response;

				setUserDetailsProp(response);

				if (code === 200) {
					const {
						firstname,
						picture,
						wc_allow_referrals: isReferralAllowed,
						promoter_referral_amount: promoterDiscount,
						referral_amount: referralAmount,
						referral_code_link: referralLink,
						is_admin,
						is_mentor,
						technical_coach_id,
						behavioural_coach_id,
						redirect_link,
						lpc = true,
					} = response;

					if (!lpc) {
						window.location.href = "/password-reset/";
					} else if (
						(window.location.pathname === "/" ||
							window.location.pathname === "/home") &&
						redirect_link !== "/"
					) {
						window.location.href = globalHostName + redirect_link;
					}
					const isStudentCheck = !(
						is_mentor ||
						is_admin ||
						behavioural_coach_id ||
						technical_coach_id
					);
					if (isStudentCheck) {
						setIsStudent(true);
					}
					if (is_admin || is_mentor) {
						setShowMentorDashboard(true);
					}
					if (technical_coach_id || behavioural_coach_id) {
						setShowCareerDashboard(true);
					}
					if (is_mentor) {
						setShowMyCourses(true);
					} else {
						setShowMyLearning(true);
					}

					setUserAvatar({
						firstname,
						picture,
					});

					if (isReferralAllowed)
						setReferrerDetails({
							promoterDiscount,
							referralAmount,
							referralLink,
						});
				} else if (
					isStaticBuild &&
					code === 500 &&
					window.location.pathname.includes("/refer")
				) {
					window.location.href = globalHostName + "/login/";
				}
			})
			.catch((err) => {
				setUserAvatar(null);
				setReferrerDetails(null);
			});
		const pathname = window.location.pathname;
		if (pathname === "/") {
			setShowExplorePrograms(true);
			const scrollHandler = () => {
				setFixHeader(false);
				if (window.scrollY > 80 && !fixHeader) {
					setFixHeader(true);
				}
			};
			window.addEventListener("scroll", scrollHandler);
			return () => {
				window.removeEventListener("scroll", scrollHandler);
			};
		} else if (pathname.includes("post-app/")) {
			const params = new URLSearchParams(window.location.href);
			const referral = params.get("referral");
			const referral2 = params.get("referral2");
			const data = {
				referral,
				referral2,
				courseSlug,
			};
			addToDataLayer(data);
		}
		try {
			fetch(`${apiBaseUrl}/token/`)
				.then((res) => res.json())
				.then((data) =>
					console.error(
						data,
						"dummy token call to be removed after 08-OCT-2021 or we stop facing optimonk cookies issue",
					),
				)
				.catch((e) => {
					console.error("ERROR WHILE FETCHING /token", { e });
				});
		} catch (e) {
			console.error(e);
		}
	}, []);

	const signOut = async () => {
		// Using try catch as the api response is a redirect to the root domain
		try {
			await fetch(signOutApiEndPoint, {
				credentials: "include",
				redirect: "manual",
			});
		} catch (err) {
			console.error("SIGNOT", err);
		}

		setReferrerDetails(null);
		setUserAvatar(null);
		if (window.location.pathname.includes("/refer"))
			window.location.href = globalHostName;
	};

	const handleHamburgerSubmenuClick = (submenu) => {
		if (hamburgerSubmenu === submenu) {
			sethamburgerSubmenu(null);
			return;
		}

		sethamburgerSubmenu(submenu);
	};
	return (
		<div>
			{!blankHeader ? (
				<HeaderWrapper
					className={`wrapper ${showExplorePrograms ? "homepage" : ""}`}
					showHamburgerMenu={showHamburgerMenu}
					hamburgerSubmenu={hamburgerSubmenu}
					numberOfCourseCategories={courses.length}
				>
					<div className="logoWrapper">
						<a href="/">
							<CloudinaryImage
								alt={logo.altTag}
								sizes={{
									default: {
										height: 40,
									},
									"1200px": { height: 40 },
								}}
								url={logo.imageurl}
								className="logo"
								lazyload
							/>
						</a>
					</div>
					<div className="linksWrapper">
						<div
							className="hamburgerIcon"
							onClick={() => setShowhamburgerMenu(true)}
						>
							<CloudinaryImage
								sizes={{ default: { height: 50 }, "1200px": { height: 50 } }}
								url={
									"https://res.cloudinary.com/springboard-images/image/upload/v1592727141/homepage-assets/navigation-bar/hamburger-menu-icon.svg"
								}
								lazyload
							/>
						</div>
						<div className="hamburgerMenu">
							<div className="closeButtonWrapper">
								<img
									src="https://res.cloudinary.com/springboard-images/image/upload/c_limit,dpr_1.0,f_svg,fl_lossy,q_auto/v1/homepage-assets/icons/dark-light-box-cross.svg"
									className="closeButton"
									alt="close modal"
									onClick={() => setShowhamburgerMenu(false)}
								/>
							</div>
							<div className="navLinksWrapper">
								<div className="navLink dropdownLink">
									<span onClick={() => handleHamburgerSubmenuClick("courses")}>
										Courses
										<CloudinaryImage
											className="rightIcon"
											sizes={{ default: { height: 10 } }}
											url="https://res.cloudinary.com/springboard-images/image/upload/v1/homepage-assets/icons/gun-arrow-right"
											lazyload
										/>
									</span>
									<div className="dropdownMenu grid courses">
										<div
											className="subMenuHeader"
											onClick={() => handleHamburgerSubmenuClick(null)}
										>
											<CloudinaryImage
												className="backIcon"
												sizes={{ default: { height: 10 } }}
												url="https://res.cloudinary.com/springboard-images/image/upload/v1592665526/homepage-assets/navigation-bar/down-arrow.svg"
												lazyload
											/>
											Courses
										</div>
										<div className="courseLinksContainer">
											{courses
												.filter((c, index) => index % 2 === 0)
												.map(({ name, links = [] }, index) => (
													<div className="category" key={`${name}-${index}`}>
														<div className="categoryName">{name}</div>
														{links.map(
															(
																{
																	label,
																	link,
																	type,
																	badges = [],
																	target = "_self",
																},
																index,
															) => (
																<CtaLink
																	Link={Link}
																	key={`${label}-${index}`}
																	type={type}
																	value={link}
																	target={target}
																	className="courseLink"
																>
																	{label}
																	{badges.map(
																		(
																			{ label, backgroundColor = "" },
																			index,
																		) => (
																			<Badge
																				backgroundColor={backgroundColor}
																				key={`${label}-${index}`}
																			>
																				{label}
																			</Badge>
																		),
																	)}
																</CtaLink>
															),
														)}
													</div>
												))}
										</div>
										{courses.length > 1 && (
											<div className="courseLinksContainer">
												{courses
													.filter((c, index) => index % 2 !== 0)
													.map(({ name, links = [] }, index) => (
														<div className="category" key={`${name}-${index}`}>
															<div className="categoryName">{name}</div>
															{links.map(
																(
																	{
																		label,
																		link,
																		type,
																		badges = [],
																		target = "_self",
																	},
																	index,
																) => (
																	<CtaLink
																		Link={Link}
																		key={`${label}-${index}`}
																		type={type}
																		value={link}
																		target={target}
																		className="courseLink"
																	>
																		{label}
																		{badges.map(
																			(
																				{ label, backgroundColor = "" },
																				index,
																			) => (
																				<Badge
																					backgroundColor={backgroundColor}
																					key={`${label}-${index}`}
																				>
																					{label}
																				</Badge>
																			),
																		)}
																	</CtaLink>
																),
															)}
														</div>
													))}
											</div>
										)}
										{exploreCareerpathsLink && (
											<>
												<div className="exploreMore">
													<hr></hr>
													<span>
														Need help choosing the right course for you?
													</span>
													<span
														id="exploreCareer" //Do not remove as it has been used to pick this element
														className="exploreCareer"
														onClick={() => setShowCareerTracksModal(true)}
													>
														Explore career paths
													</span>
												</div>
											</>
										)}
									</div>
								</div>
								{outcomesLink && (
									<div className="navLink">
										<a href="/outcomes">Outcomes</a>
									</div>
								)}
								{howItWorks.length == 0 ? (
									<div className="navLink">
										<a href="/how-it-works">How It Works</a>
									</div>
								) : (
									<div className="navLink dropdownLink">
										<span
											onClick={() => handleHamburgerSubmenuClick("howItWorks")}
										>
											How It Works
											<CloudinaryImage
												className="rightIcon"
												sizes={{ default: { height: 10 } }}
												url="https://res.cloudinary.com/springboard-images/image/upload/v1/homepage-assets/icons/gun-arrow-right"
												lazyload
											/>
										</span>
										<div className="dropdownMenu howItWorks">
											<div
												className="subMenuHeader"
												onClick={() => handleHamburgerSubmenuClick(null)}
											>
												<CloudinaryImage
													className="backIcon"
													sizes={{ default: { height: 10 } }}
													url="https://res.cloudinary.com/springboard-images/image/upload/v1592665526/homepage-assets/navigation-bar/down-arrow.svg"
													lazyload
												/>
												How It Works
											</div>
											{howItWorks.map(
												({ label, link, type, target = "_self" }, index) => (
													<CtaLink
														Link={Link}
														type={type}
														value={link}
														target={target}
														className="link"
														key={`${label}-${index}`}
													>
														{label}
													</CtaLink>
												),
											)}
										</div>
									</div>
								)}
								{mentors.length == 0 ? (
									<div className="navLink">
										<a href="/mentors">Mentors</a>
									</div>
								) : (
									<div className="navLink dropdownLink">
										<span
											onClick={() => handleHamburgerSubmenuClick("mentors")}
										>
											Mentors
											<CloudinaryImage
												className="rightIcon"
												sizes={{ default: { height: 10 } }}
												url="https://res.cloudinary.com/springboard-images/image/upload/v1/homepage-assets/icons/gun-arrow-right"
											/>
										</span>
										<div className="dropdownMenu mentors">
											<div
												className="subMenuHeader"
												onClick={() => handleHamburgerSubmenuClick(null)}
											>
												<CloudinaryImage
													className="backIcon"
													sizes={{ default: { height: 10 } }}
													url="https://res.cloudinary.com/springboard-images/image/upload/v1592665526/homepage-assets/navigation-bar/down-arrow.svg"
												/>
												Mentors
											</div>
											{mentors.map(
												({ label, link, type, target = "_self" }, index) => (
													<CtaLink
														Link={Link}
														type={type}
														value={link}
														target={target}
														className="link"
														key={`${label}-${index}`}
													>
														{label}
													</CtaLink>
												),
											)}
										</div>
									</div>
								)}
								{studentsLinkWithoutDropdown ? (
									<div className="navLink">
										<a href="/students">Students</a>
									</div>
								) : (
									<div className="navLink dropdownLink">
										<span
											onClick={() => handleHamburgerSubmenuClick("students")}
										>
											Students
											<CloudinaryImage
												className="rightIcon"
												sizes={{ default: { height: 10 } }}
												url="https://res.cloudinary.com/springboard-images/image/upload/v1/homepage-assets/icons/gun-arrow-right"
												lazyload
											/>
										</span>
										<div className="dropdownMenu students">
											<div
												className="subMenuHeader"
												onClick={() => handleHamburgerSubmenuClick(null)}
											>
												<CloudinaryImage
													className="backIcon"
													sizes={{ default: { height: 10 } }}
													url="https://res.cloudinary.com/springboard-images/image/upload/v1592665526/homepage-assets/navigation-bar/down-arrow.svg"
													lazyload
												/>
												Students
											</div>
											{students.map(
												({ label, link, type, target = "_self" }, index) => (
													<CtaLink
														Link={Link}
														type={type}
														value={link}
														target={target}
														className="link"
														key={`${label}-${index}`}
													>
														{label}
													</CtaLink>
												),
											)}
										</div>
									</div>
								)}
								{forCompanies && forCompanies.length ? (
									<div className="navLink dropdownLink">
										<span
											onClick={() =>
												handleHamburgerSubmenuClick("forCompanies")
											}
										>
											For Companies
											<CloudinaryImage
												className="rightIcon"
												sizes={{ default: { height: 10 } }}
												url="https://res.cloudinary.com/springboard-images/image/upload/v1/homepage-assets/icons/gun-arrow-right"
												lazyload
											/>
										</span>
										<div className="dropdownMenu forCompanies">
											<div
												className="subMenuHeader"
												onClick={() => handleHamburgerSubmenuClick(null)}
											>
												<CloudinaryImage
													className="backIcon"
													sizes={{ default: { height: 10 } }}
													url="https://res.cloudinary.com/springboard-images/image/upload/v1592665526/homepage-assets/navigation-bar/down-arrow.svg"
													lazyload
												/>
												For Companies
											</div>
											{forCompanies.map(
												({ label, link, type, target = "_self" }, index) => (
													<CtaLink
														Link={Link}
														type={type}
														value={link}
														target={target}
														className="link"
														key={`${label}-${index}`}
													>
														{label}
													</CtaLink>
												),
											)}
										</div>
									</div>
								) : null}
								<div className="navLink">
									<a href="/blog">Blog</a>
								</div>
							</div>
							<div className="authWrapper">
								{!userAvatar && (
									<Button
										type="outline"
										onClick={() => setShowLoginModal(true)}
										aria-haspopup="dialog"
										aria-expanded={showLoginModal}
										aria-controls="authentication-login-modal"
									>
										Log in
									</Button>
								)}
							</div>
						</div>
						{userAvatar && (
							<UserAvatarWrapper
								onClick={() => setShowUserMenu(!showUserMenu)}
								showUserMenu={showUserMenu}
							>
								<div className="imageWrapper">
									<img src={userAvatar.picture} />
								</div>
								<span className="userName">{userAvatar.firstname}</span>
								<div className="userMenuWrapper">
									<div
										className="backdrop"
										onClick={() => setShowUserMenu(false)}
									></div>
									<div className="userMenu">
										{showMentorDashboard && (
											<a className="seperator" href="/mentor-dashboard">
												Mentor Dashboard
											</a>
										)}
										{showCareerDashboard && (
											<a className="seperator" href="/career-dashboard">
												Coach Dashboard
											</a>
										)}
										{showMyLearning && (
											<a className="seperator" href="/profile/#/my-learning">
												My Learning
											</a>
										)}
										{showMyCourses && (
											<a className="seperator" href="/profile/#/my-courses">
												My Courses
											</a>
										)}
										<hr />
										<a href="/profile">Profile</a>
										<a href="/profile/#/billing">My Account</a>
										{referrerDetails && !isStudent && (
											<CtaLink type="internal" value={"/invite/refer"}>
												Earn ${referrerDetails.promoterDiscount}
											</CtaLink>
										)}
										{referrerDetails && isStudent && (
											<CtaLink type="internal" value={"/invite/refer"}>
												Give ${referrerDetails.referralAmount}
											</CtaLink>
										)}
										<a className="seperator" href="/profile/#/settings">
											Settings
										</a>
										<hr />
										<span onClick={signOut}>Sign Out</span>
									</div>
								</div>
							</UserAvatarWrapper>
						)}
						<div
							className={`explore-programs ${
								showExplorePrograms && fixHeader ? "active" : ""
							}`}
							onClick={() => scrollToExplorePrograms()}
						>
							<Button className="primary-button">Explore programs</Button>
						</div>
					</div>
					<AuthenticationModal
						show={showLoginModal}
						apiBaseUrl={apiBaseUrl}
						globalHostName={globalHostName}
						isStaticBuild={isStaticBuild}
						getXCSRFToken={getXCSRFToken}
						handleModalClose={() => setShowLoginModal(false)}
						loginApiEndPoint={`${apiBaseUrl}/accounts/login/`}
					/>
					{referrerDetails && (
						<ReferralModal
							show={showReferrerModal}
							{...referrerDetails}
							handleModalClose={() => setShowReferrerModal(false)}
						/>
					)}
					<CareerTracksModal
						show={showCareerTracksModal}
						careerTracks={careerTracks}
						careerAssessmentTestLink={careerAssessmentTestLink}
						exploreCareerpathsHeader={exploreCareerpathsHeader}
						handleModalClose={() => setShowCareerTracksModal(false)}
					/>
				</HeaderWrapper>
			) : (
				<HeaderWrapper>
					<div className="logoWrapper">
						<a href="/">
							<CloudinaryImage
								alt={logo.altTag}
								sizes={{
									default: {
										height: 40,
									},
									"1200px": { height: 40 },
								}}
								url={logo.imageurl}
								className="logo"
								lazyload
							/>
						</a>
					</div>
				</HeaderWrapper>
			)}
		</div>
	);
};
export const LinkType = Proptypes.shape({
	value: Proptypes.string,
	type: Proptypes.oneOf(["internal", "external", "hash"]),
});
export const LinkWithBadgeType = Proptypes.shape({
	label: Proptypes.string,
	link: Proptypes.string,
	type: Proptypes.oneOf(["internal", "external", "hash"]),
	badges: Proptypes.arrayOf(
		Proptypes.shape({
			label: Proptypes.string,
			backgroundColor: Proptypes.string,
		}),
	),
});
export const CareerTrackWithCta = Proptypes.shape({
	header: Proptypes.string,
	description: Proptypes.string,
	image: Proptypes.shape({
		image: Proptypes.string,
		altTag: Proptypes.string,
	}),
	cta: Proptypes.arrayOf(
		Proptypes.shape({
			buttonText: Proptypes.string,
			type: Proptypes.string,
			link: Proptypes.shape({
				enable: Proptypes.bool,
				link: Proptypes.string,
				target: Proptypes.string,
				type: Proptypes.string,
			}),
			color: Proptypes.string,
		}),
	),
	section: Proptypes.arrayOf(
		Proptypes.shape({
			title: Proptypes.string,
			description: Proptypes.string,
		}),
	),
});
Header.propTypes = {
	logo: Proptypes.shape({
		imageurl: Proptypes.string,
		altTag: Proptypes.string,
	}),
	courses: Proptypes.arrayOf(LinkWithBadgeType),
	students: Proptypes.arrayOf(LinkWithBadgeType),
	howItWorks: Proptypes.arrayOf(LinkWithBadgeType),
	forCompanies: Proptypes.arrayOf(LinkWithBadgeType),
	mentors: Proptypes.arrayOf(LinkWithBadgeType),
	apiBaseUrl: Proptypes.string,
	Link: Proptypes.func,
	exploreCareerpathsLink: Proptypes.bool,
	careerAssessmentTestLink: LinkType,
	studentsLinkWithoutDropdown: Proptypes.bool,
	careerTracks: Proptypes.arrayOf(CareerTrackWithCta),
	exploreCareerpathsHeader: Proptypes.string,
	isStaticBuild: Proptypes.bool,
	blankHeader: Proptypes.bool,
};
Header.defaultProps = {
	logo: {
		imageurl: "",
		altTag: "",
	},
	course: [],
	students: [],
	howItWorks: [],
	forCompanies: [],
	mentors: [],
	exploreCareerpathsLink: false,
	careerAssessmentTestLink: null,
	apiBaseUrl: "",
	Link: AElement,
	studentsLinkWithoutDropdown: false,
	careerTracks: [],
	exploreCareerpathsHeader: "",
	isStaticBuild: true,
	blankHeader: false,
};
export default Header;
